export default __webpack_public_path__ + "static/media/star.c6071910.png";